import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NgxModalWindowModule } from 'ngx-modal-window';
import { HttpClientModule } from "@angular/common/http";
import { HttpModule } from "@angular/http";

import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
  NgxUiLoaderHttpModule
} from "ngx-ui-loader";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {MatTabsModule} from '@angular/material/tabs';

import { ThreedviewComponent } from './views/threedview/threedview.component';
import { NgxFixedFooterModule } from 'ngx-fixed-footer';
// import {FlexLayoutModule} from '@angular/flex-layout';
// import {MdButtonModule, MdCheckboxModule} from '@angular/material';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  FormGroup,
  FormControl,
  FormsModule,
  ReactiveFormsModule 
} from "@angular/forms";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "black",
  bgsOpacity: 0.5,
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 60,
  bgsType: SPINNER.rectangleBounce,
  fgsColor: "black",
  fgsPosition: POSITION.centerCenter,
  fgsSize: 60,
  // fgsType: false,
  logoSize: 400,
  logoUrl: "assets/g7.gif",
  overlayColor: "rgb(10 9 10)",
  pbColor: "#FF0000",
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 2,
  // text: "Pinesphere",
  textColor: "#FFFFFF",
  textPosition: POSITION.centerCenter
};
@NgModule({
  declarations: [
    AppComponent,
    ThreedviewComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgxSliderModule,
    HttpClientModule,
    HttpModule,
    NgxModalWindowModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxFixedFooterModule,
     BrowserAnimationsModule,
     MatTabsModule,
     NgbModule
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
